// Asesoría personalizada (Executive Mentoring): bolsa de horas del programa.
import apiService from './api';

const unwrap = (r: any) => r?.data?.data ?? r?.data;

export type AdvisoryStatus = 'pending' | 'approved' | 'rejected';
export type AdvisoryLang = 'es' | 'en';

export interface AdvisoryPool {
  total: number;      // horas de la bolsa del programa
  used: number;       // aprobadas
  pending: number;    // en revisión
  remaining: number;  // total - aprobadas
  available: number;  // lo que aún se puede pedir (descuenta pendientes)
}

export interface AdvisoryRequest {
  id: number;
  mentor_user_id: number;
  mentor_name: string | null;
  mentor_email: string | null;
  hours: number;
  detail: string;
  status: AdvisoryStatus;
  language: AdvisoryLang | null;
  decision_reason: string | null;
  decided_by_name: string | null;
  decided_at: string | null;
  created_at: string;
}

export interface AdvisoryByMentor {
  mentor_user_id: number;
  mentor_name: string | null;
  approved: number;
  pending: number;
  rejected: number;
}

export const LANG_LABEL: Record<AdvisoryLang, string> = { es: 'Español', en: 'Inglés' };

/** Mensaje legible de un error de la API (CodeIgniter fail()). */
export const apiError = (err: any, fallback: string): string => {
  const d = err?.response?.data;
  const m = d?.messages;
  if (m) return Object.values(m).join(' · ');
  return d?.message || fallback;
};

const advisoryApi = {
  // Mentor
  getMine: async (): Promise<{ pool: AdvisoryPool; requests: AdvisoryRequest[] }> =>
    unwrap(await apiService.get('/advisory/mine')),
  create: async (detail: string) => unwrap(await apiService.post('/advisory', { detail })),

  // Admin
  getAll: async (): Promise<{ pool: AdvisoryPool; requests: AdvisoryRequest[]; by_mentor: AdvisoryByMentor[] }> =>
    unwrap(await apiService.get('/admin/advisory')),
  approve: async (id: number, language: AdvisoryLang) =>
    unwrap(await apiService.post(`/admin/advisory/${id}/approve`, { language })),
  reject: async (id: number, reason: string) =>
    unwrap(await apiService.post(`/admin/advisory/${id}/reject`, { reason })),
  setTotal: async (total: number) => unwrap(await apiService.put('/admin/advisory/total', { total })),
};

export default advisoryApi;
